import { BigNumber } from 'bignumber.js'

export const PET_BASE_URL = '/api/pets/bzemouam/'

export const SORT_OPTIONS = [{
  sortName: 'price',
  sortBy: 'asc',
  key: 1,
  name: 'Price',
}, {
  sortName: 'price',
  sortBy: 'desc',
  key: 2,
  name: 'Price',
}, {
  sortName: 'battlePower',
  sortBy: 'asc',
  key: 3,
  name: 'Power',
}, {
  sortName: 'battlePower',
  sortBy: 'desc',
  key: 4,
  name: 'Power',
}]

export interface PetProps {
  tokenId: string
  name: string
  price: number
  battlePower: number
  petUrl: string
  petToGet: BigNumber
  bakeToGet: BigNumber
  auctionPrice?: string
  nftType?: number
  maxBidPrice: string
  level: string
}

export interface MyPetProps {
  type: string
  id: string
  petType: number
  battlePower: number
  name: string
  petUrl: string
  petToGet: string
  bakeToGet: string
  experience: string
  stamina: string
  weapon: undefined | PetProps
  shield: string
  helmet: string
  armour: string
  staking: boolean
  extraUintA: string
  extraUintB: string
  extraUintC: string
  extraUintD: string
  extraUintE: string
  extraUintF: string
  extraUintG: string
  extraUintH: string
  extraStringA: string
  extraStringB: string
  extraStringC: string
  price: number
  auctionPrice?: string
  nftType?: number
  maxBidPrice: string
  level?: string
  exchangeAddress?: string
}
